import { useState } from "react";
import "./ComingSoon.css";

export default function ServicesPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (email) setSubmitted(true);
  }

  return (
    <div className="cs-page">
      <div className="cs-inner">
        <div className="cs-eyebrow">
          <div className="cs-line"></div>
          <span>COMING SOON</span>
          <div className="cs-line"></div>
        </div>

        <div className="cs-icon">✦</div>

        <h1 className="cs-title">Our <em>Services</em></h1>
        <p className="cs-sub">A full suite of premium travel and hospitality services across Albania — crafted for travellers who expect the best.</p>

        <div className="cs-features">
          <div className="cs-feature">
            <span className="cs-feat-icon">✦</span>
            <span>Curated accommodation across Albania</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feat-icon">✦</span>
            <span>Premium vehicle rentals & transfers</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feat-icon">✦</span>
            <span>Personalised travel planning & concierge</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feat-icon">✦</span>
            <span>Property management for owners</span>
          </div>
        </div>

        {!submitted ? (
          <form className="cs-form" onSubmit={handleSubmit}>
            <p className="cs-form-label">Be the first to know when we launch</p>
            <div className="cs-input-row">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button type="submit">Notify Me</button>
            </div>
          </form>
        ) : (
          <div className="cs-thanks">
            <span>✓</span> You're on the list — we'll be in touch!
          </div>
        )}

        <a href="/" className="cs-back">← Back to BookingAlb</a>
      </div>
    </div>
  );
}
